var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceReady(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5868 12.3179C24.7863 11.2742 23.2135 11.2742 22.413 12.3179L19.8408 15.6713C19.5037 16.1107 18.9996 16.3907 18.4485 16.4446L14.2833 16.8518C12.9184 16.9853 12.0897 18.4215 12.6572 19.6699L14.2487 23.1714C14.4878 23.6972 14.4878 24.3007 14.2488 24.8266L12.6572 28.3281C12.0897 29.5765 12.9184 31.0128 14.2833 31.1462L18.4484 31.5534C18.9996 31.6073 19.5037 31.8873 19.8408 32.3267L22.413 35.6801C23.2135 36.7238 24.7863 36.7238 25.5868 35.6801L28.1591 32.3267C28.4961 31.8873 29.0003 31.6073 29.5514 31.5534L33.7165 31.1462C35.0814 31.0128 35.9101 29.5765 35.3426 28.3281L33.7511 24.8266C33.5121 24.3007 33.5121 23.6972 33.7511 23.1714L35.3427 19.6699C35.9101 18.4215 35.0814 16.9853 33.7166 16.8518L29.5514 16.4446C29.0002 16.3907 28.4961 16.1107 28.1591 15.6713L25.5868 12.3179ZM24 27.7491C26.071 27.7491 27.75 26.0702 27.75 23.9991C27.75 21.928 26.071 20.2491 24 20.2491C21.9289 20.2491 20.25 21.928 20.25 23.9991C20.25 26.0702 21.9289 27.7491 24 27.7491Z",
    fill: "#363A4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceReady);
export default __webpack_public_path__ + "static/media/service_ready.433e2db3995731c95fdc4712cb043686.svg";
export { ForwardRef as ReactComponent };